import React from 'react'
import { productionFiles } from '../productionFiles'

export default function PersonalizationDetails({ item }) {
    if (!item.personalizationType) return null
    const snapshot = item.personalizationTemplateSnapshot || {}
    const texts = item.personalizationMetadata?.textValues || {}
    const printReadyUrl = item.personalizationAssets?.printReadyUrl
    return <div style={{ marginTop: 8, padding: 10, background: '#eef6ff', fontSize: 12 }}>
        <strong>Personalizado:</strong> {snapshot.name || item.personalizationTemplateSlug || 'Una imagen'}<br />
        {(snapshot.version || item.personalizationRendererVersion) && <div>Versión: {snapshot.version || item.personalizationRendererVersion}</div>}
        <div>{[item.size, item.material, item.frame, item.marialuisa].filter(Boolean).join(' / ')}</div>
        {Object.entries(texts).map(([key, value]) => typeof value === 'string' && <div key={key}>{key}: {value}</div>)}
        {printReadyUrl ? <div style={{ margin: '8px 0' }}>
            <strong><a href={printReadyUrl} target="_blank" rel="noopener noreferrer">Descargar archivo final para imprimir</a></strong>
        </div> : item.personalizationType === 'template' && <div style={{ margin: '8px 0' }}>
            Archivo final pendiente de generación
        </div>}
        {productionFiles(item).map((file, index) => <div key={index}>
            Original {file.label}: {file.url
                ? <a href={file.url} target="_blank" rel="noopener noreferrer">Descargar archivo original</a>
                : <span>Archivo original no disponible</span>}
        </div>)}
    </div>
}
